import React from "react";

const Terms = () => {
  const termsData = [
    {
      title: "1. Payment and Refund Policy",
      content: (
        <ul className="list-disc pl-4">
          <li>Refund requests can be made via email at support@english.com.</li>
          <li>
            All refunds are subject to approval and processing time of 7-10
            business days.
          </li>
          <li>
            Payments made for English-speaking courses are non-transferable to
            other courses or services.
          </li>
        </ul>
      ),
    },
    {
      title: "2. English Language Courses",
      content: (
        <ul className="list-disc pl-4">
          <li>
            English offers various English-speaking courses tailored for
            beginners, intermediate, and advanced learners.
          </li>
          <li>
            Our courses include live sessions, interactive modules, and
            downloadable resources for self-paced learning.
          </li>
          <li>
            Certificates of completion are provided upon successfully finishing
            the course and meeting the requirements.
          </li>
        </ul>
      ),
    },
  ];

  return (
    <div className="terms-and-conditions-container p-4 md:p-8 font-sans mt-24">
      <h1 className="text-center text-3xl font-bold mb-8 text-gray-800">
        Terms and Conditions
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-6 justify-center mt-14">
        {termsData.map((term, index) => (
          <div
            key={index}
            className="card bg-blue-50 p-8 rounded-lg shadow-md hover:shadow-lg transition-all border border-gray-200"
          >
            <h2 className="text-xl font-semibold mb-4 text-blue-600">
              {term.title}
            </h2>
            <div className="text-sm text-gray-700">{term.content}</div>
          </div>
        ))}
      </div>

      <div className="text-center mt-12 mb-14">
        <a
          href="/Terms.pdf"
          download
          className="bg-blue-600 text-white px-8 py-4 rounded-lg hover:bg-blue-700 transition-all text-lg"
        >
          Download PDF
        </a>
      </div>
    </div>
  );
};

export default Terms;
